import {Dispatch} from 'redux';
import {
  MATCH_LINEUPS_BY_EVENT_ID_GET_INVALIDATE,
  MATCH_LINEUPS_BY_EVENT_ID_GET_REQUEST,
  MATCH_LINEUPS_BY_EVENT_ID_GET_RESPONSE,
} from '../../actionTypes';
import {MatchLineups} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {lineupDataByEventId} from '../../../API/sportEvents';
import {
  MatchLineupsAction,
  MatchLineupsByEventIdGetInvalidateAction,
  MatchLineupsByEventIdGetRequestAction,
  MatchLineupsByEventIdGetResponseAction,
} from '../types';
import {beLineupDataToMatchLineups} from '../../../API/utils';

/**
 * Action creator for the get request of the lineup request (by event id)
 * @param id
 */
const getLineupDataByEventIdGetRequest = (id: string): MatchLineupsByEventIdGetRequestAction => ({
  type: MATCH_LINEUPS_BY_EVENT_ID_GET_REQUEST,
  payload: id,
});

/**
 * Action creator for the get response of the lineup request (by event id)
 */
const getMatchLineupsByEventIdGetResponse = (data: MatchLineups): MatchLineupsByEventIdGetResponseAction => ({
  type: MATCH_LINEUPS_BY_EVENT_ID_GET_RESPONSE,
  payload: {data},
});

/**
 * Action creator for the get invalidation of the lineup request (by event id)
 * @param error
 */
const getMatchLineupsByEventIdGetInvalidate = (error: Error): MatchLineupsByEventIdGetInvalidateAction => ({
  type: MATCH_LINEUPS_BY_EVENT_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getMatchLineupsDataByEventId = (id: string) => (dispatch: Dispatch): Promise<MatchLineupsAction> => {
  dispatch(getLineupDataByEventIdGetRequest(id));

  return lineupDataByEventId(id)
    .then(beLineupDataToMatchLineups)
    .then((data: MatchLineups) => dispatch(getMatchLineupsByEventIdGetResponse(data)))
    .catch((error: Error) => dispatch(getMatchLineupsByEventIdGetInvalidate(error)));
};

export default getMatchLineupsDataByEventId;
